import 'flexslider';
import $ from 'jquery';
import NProgress from 'nprogress';

export default function (flexsliderCont, body) {
  flexsliderCont.flexslider({
    directionNav: false,
    animation   : 'slide',

    start: function () {
      NProgress.done();

      let color = $('.flex-active-slide').find('.trailer-info').data('color');

      body.addClass('trailer' + color);
    },

    after: function () {
      let color = $('.flex-active-slide').find('.trailer-info').data('color');

      body.removeClass(function (index, css) {
        return (css.match(/(^|\s)trailer\S+/g) || []).join(' ');
      }).addClass('trailer' + color);
    },
  });
}
